import { Injectable } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class DocArticleService {
    constructor(private datatask: DataTaskService) {}

    /**
     * Retrieves the docarticle of the article with the given keyno.
     *
     * @param docarticleKeyno the keyno of the doc article to retrieve.
     * @returns a promise containing the docarticle with the given keyno.
     */
    public async getDocArticle(docarticleKeyno: string | number): Promise<DocArticleGet> {
        return (await this.datatask.Post(1376, { docarticle_keyno: docarticleKeyno }))[0];
    }

    /**
     * Saves the given docarticle object.
     *
     * @param docarticle the docarticle object to save.
     * @returns promise containing errorcode and errormessage for the save procedure.
     */
    public async saveDocArticle(docarticle: DocArticleGet): Promise<{ docarticle_keyno: string; errorcode: string; errormessage: string }> {
        return (await this.datatask.Post(1377, docarticle))[0];
    }

    /**
     * Deletes the docarticle with the given keyno.
     *
     * @param docarticleKeyno the keyno of the docarticle to delete.
     * @returns promise containing errorcode and errormessage for the delete procedure.
     */
    public async deleteDocArticle(docarticleKeyno: string | number): Promise<{ errorcode: string; errormessage: string }> {
        return (await this.datatask.Post(1378, { docarticle_keyno: docarticleKeyno }))[0];
    }

    /**
     * Retrieves list of docarticles children to the docarticle of the given keyno. To get root articles pass 0 as parameter.
     *
     * @param docarticleKeyno the keyno fo the parent docarticle to retrieve child articles for.
     * @returns a promise containing a list of child articles for the given parent docarticle keyno.
     */
    public getDocarticleList(docarticleKeyno: string | number): Promise<Item[]> {
        return this.datatask.Post(1375, { docarticle_keyno: docarticleKeyno });
    }

    public getDocArticlesTree(): Promise<Item[]> {
        return this.datatask.Post(3762);
    }
}

export interface DocArticleGet {
    docarticle_keyno: string | number;
    title: string;
    html_content_base64: string;
    docarticle_keyno_belongto: string | number;
    reg_portal_user_name: string;
    reg_date: string;
    mod_portal_user_name: string;
    mod_date: string;
    nbr_of_read: string | number;
    docarticle_keyno_top: string | number;
    sub_docarticle_admin: '1' | '0';
    page_heading: string;
    gb_docarticle_main: string;
}
